import { Tab } from '../../../../../../views/team/reports';

export default {
  tabs: {
    [Tab.General]: 'Général',
    [Tab.SignedLive]: 'Signé / Actif',
    [Tab.MRR]: 'MRR',
    [Tab.CollectedCommission]: 'Commission',
  },
};
